import React from 'react'
import NavbarUser from '../../components/navbar/NavbarUser'
import CssBaseline from '@mui/material/CssBaseline';

function Deshboard() {
  return (
    <div>
        <NavbarUser />
         <div>
                <React.Fragment>
                  {/* <CssBaseline /> */}
                  <div>
                    deshboard
                    <div>
                    </div>
        
                    <div>
                    </div>
        
                    <div>
                    </div>
        
                    <div>
                    </div>
                  </div>
                </React.Fragment>
              </div>
    </div>
  )
}

export default Deshboard